import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

export const SlideAnimation: FC<{ location: ReturnType<typeof useLocation> }> = ({
    children, location,
}) => (
    <TransitionGroup>
        <CSSTransition
            key={location.key}
            classNames="slide-animation"
            timeout={1000}
        >
            {children}
        </CSSTransition>
    </TransitionGroup>
);
